import { render, staticRenderFns } from "./MediaLogin.vue?vue&type=template&id=0a5a7c64&scoped=true"
import script from "./MediaLogin.vue?vue&type=script&lang=js"
export * from "./MediaLogin.vue?vue&type=script&lang=js"
import style0 from "./MediaLogin.vue?vue&type=style&index=0&id=0a5a7c64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a7c64",
  null
  
)

export default component.exports